import { BadgeCheck, HatGlasses, HandCoins } from "lucide-react";

const homeBadges = [
  { icon: <HandCoins className="w-5 h-5" />, title: "100% gratuit" },
  { icon: <HatGlasses className="w-5 h-5" />, title: "Anonyme" },
  { icon: <BadgeCheck className="w-5 h-5" />, title: "Données sécurisées" },
]

export default homeBadges;